export const base_path = "/";
export const img_path = "/react/template/";

// Base Url Path
// export const apibaseurl = "http://localhost:8989";
export const apibaseurl = "https://engine.weconnect1.com:8989";

// export const apibaseurl = "https://engine.weconnect1.com:8989";

export const jwttoken = localStorage.getItem("token");
export const employee_name = localStorage.getItem("employee_name");
export const employee_id = localStorage.getItem("employee_id");
export const employee_email = localStorage.getItem("employee_email");
export const employee_photo = localStorage.getItem("employee_photo");
export const is_manager = localStorage.getItem("is_manager");
export const is_exclusions = localStorage.getItem("is_exclusions");
export const skip_manager = localStorage.getItem("skip_manager");
export const is_hod = localStorage.getItem("is_hod");
export const manager_pms = localStorage.getItem("manager_pms");
export const isSupportteam = localStorage.getItem("supportMember");
export const isMasterLogin = localStorage.getItem("isMasterLogin");
export const IsHrHead = localStorage.getItem("hrHead");
export const IsNewEmployee = localStorage.getItem("isNewEmployee");
export const can_raise_recruitment = localStorage.getItem(
  "can_raise_recruitment",
);





export const get_prefilled_details = `/api/get-buddyname`;
// export const get_buddy_name_details = `${apibaseurl}/api/get-buddyname`;

export const fetch_buddy_feedback = `/api/fetch-buddy-feedback`;
export const create_buddy_feedback = `${apibaseurl}/api/buddy/save`;
export const create_monthly_feedback = `${apibaseurl}/api/onboarding/save`;

export const fetch_induction_feedback = `/api/fetch-induction`;
export const create_induction_feedback = `/api/save-induction`;
export const create_probation_form = `${apibaseurl}/api/probation/save`;

export const GET_PROBATION_BY_EMPID = `/api/probation/emp`;
export const GET_MONTHLY_BY_EMPID = `/api/get-monthly-feedback-form-by-id`;
export const GET_EMP_REQUIRED_DATA2 = `/api/fetch-employee-detail`;
export const GET_REGISTERED_EMP_REQUIRED_DATA = `/api/get-employee-details`;

export const fetch_employee_list = `/api/replacement-list`;
export const get_employee_by_id = `/api/replacement`;

export const get_payslip_by_id = `/api/fetch-payslip`;

export const save_monthly_feedback_form = `/api/save-monthly-feedback-form`;

// export const get_enabled_monthly_list = `/api/fetch-all-monthly-feedback-form`;
export const get_enabled_monthly_list = `/api/get-all-active-monthly-feedback-form`;
export const get_monthly_form_by_id = `/api/get-monthly-feedback-form-by-id/`;
export const get_enabled_probation_list = `/api/fetch-all-probation-form`;

export const get_new_joiners = `/api/fetch-all-new-joiner`;
export const get_new_emp_by_id = `/api/new-joiner/fetch-employee-details`;
